<template>
    <div class="dialog-inner layout-image" style="padding-top:0;">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" :show-message="true" class="form-col2">
            <div class="layout-image-left">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="姓名">
                            <el-input type="text" v-model="form.name" size="small" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="押金金额" prop="depositMoney" clearable>
                            <el-input type="number" v-model="form.depositMoney" size="small" maxlength="50" @blur="fieldTrim(form, 'depositMoney')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="押金缴纳照片" prop="depositImage">
                            <UploadImage
                                text="押金缴纳照片"
                                :image-url="form.depositImage ? BASE_URL + form.depositImage.substring(1) : ''"
                                :base-url="BASE_URL"
                                :upload-url="BASE_URL + 'v1/upload-img'"
                                @success="handleUploadDepositImageChange"
                                @remove="handleUploadDepositImageRemove"
                            ></UploadImage>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-row :gutter="20" class="submit-row">
                    <el-col :span="24">
                        <el-form-item>
                            <el-button type="primary" @click="handleSubmit" :loading="submitting" size="small">提交</el-button>
                            <el-button @click="resetForm" size="small">重置</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
import http from "@/utils/http"
import common from "@/utils/common"
import verify from "@/utils/verify"
import UploadImage from "@/components/UploadImage.vue";

export default {
    name: "SubmitDeposit",
    components: {
        UploadImage
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            BASE_URL: http.BASE_URL,
            form: {
                workerId: "",
                name: "",
                depositMoney: "",
                depositImage: "",
            },
            rules: {
                depositMoney: [{ required: true, message: "请输入押金金额" }],
                depositImage: [{ required: true, message: "押金缴纳照片不能为空"}],
            },
            submitting: false
        };
    },
    watch: {},
    created() {
        this.form.workerId = this.params.id;
        this.loadData();
    },
    methods: {
        ...common,
        ...verify,
        loadData() {
            let params = {};
            params.id = this.params.id;
            http.get("v1/worker/detail", { params: params }).then(req => {
                if (req.data.code == http.SUCCESS) {
                    this.form = {
                        workerId: req.data.data.id,
                        name: req.data.data.name,
                        depositMoney: req.data.data.depositMoney,
                        depositImage: req.data.data.depositImage
                    };
                }
                else {
                    this.showError(req.data.msg);
                }
            }).catch(err => {
                this.httpCatch(err);
            });
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    http.post("v1/worker/workerDeposit", this.form).then(req => {
                        this.submitting = false;
                        if (req.data.code == http.SUCCESS) {
                            this.showSuccess("提交成功", () => {
                                this.$emit("done");
                            });
                        }
                        else {
                            this.showError(req.data.msg);
                        }
                    }).catch(err => {
                        this.submitting = false;
                        this.httpCatch(err);
                    });
                }
                else {
                    return false;
                }
            });
        },
        handleUploadDepositImageChange(data) {
            this.form.depositImage = data.url;
        },
        handleUploadDepositImageRemove() {
            this.form.depositImage = "";
        },
    },
};
</script>

<style scoped>
</style>